import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const AnalyticsActions = require('../../actions/AnalyticsActions');
const AnalyticsStore = require('../../stores/AnalyticsStore');
import ActivityStatsCharts from './ActivityStatsCharts';

const propTypes = {
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const defaultProps = {};

class ActivityStatsChartsChannel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            analyticsStoreState: AnalyticsStore.getState(),
            getStatsActionId: null
        };

        this.getActStatsData = this.getActStatsData.bind(this);
        this.unsubscribes = [AnalyticsStore.listen(this.onAnalyticsStoreChage.bind(this))];
    }

    componentDidMount() {
        if (!this.state.analyticsStoreState.activityStats[this.props.activityId]) {
            this.getActStatsData(this.props.channelId, this.props.activityId);
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.activityId !== this.props.activityId
            && !this.state.analyticsStoreState.activityStats[this.props.activityId]
        ) {
            this.getActStatsData(this.props.channelId, this.props.activityId);
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getActStatsData(channelId, activityId) {
        const actionId = uuid.v4();
        this.setState({ getStatsActionId: actionId }, () => {
            AnalyticsActions.getActivityStatsChannel(
                actionId,
                {
                    activityId: activityId,
                    channelId: channelId
                }
            );
        });
    }

    onAnalyticsStoreChage(state) {
        let additionalState = {};

        if (state.action.id === this.state.getStatsActionId) {
            additionalState = { ...additionalState, getStatsActionId: null };
        }

        this.setState({ analyticsStoreState: state, ...additionalState });
    }

    render() {
        const activityStats = this.state.analyticsStoreState.activityStats[this.props.activityId];
        if (!activityStats) {
            return null;
        }

        return (
            <ActivityStatsCharts
                className="text-centered"
                avgTimePlayed={activityStats.avgTimePlayed}
                totalCompleted={activityStats.totalCompleted}
                timePlayedGraphData={activityStats.timePlayedGraphData}
                completionGraphData={activityStats.completionGraphData}
                avgScore={activityStats.avgScore}
                scoreGraphData={activityStats.scoreGraphData}
            />
        );
    }
}

ActivityStatsChartsChannel.propTypes = propTypes;
ActivityStatsChartsChannel.defaultProps = defaultProps;

export default ActivityStatsChartsChannel;